export type Task = 'ride' | 'composition' | 'camera' | 'export';
export const TASKS: { id: Task; title: string; shortTitle: string; subtitle: string }[] = [
  { id: 'ride', title: 'Trace & format', shortTitle: 'Fmt', subtitle: 'Footage, title & format' },
  { id: 'composition', title: 'Composition', shortTitle: 'Comp', subtitle: 'Map & information' },
  { id: 'camera', title: 'Camera & motion', shortTitle: 'Cam', subtitle: 'Shape the journey' },
  { id: 'export', title: 'Review & export', shortTitle: 'Exp', subtitle: 'Check your film' },
];
